"use client";
import React, { useState } from "react";
import "./Dashboard.css";

import LiveDashboard from "./LiveDashboard.jsx";
import DetailedDashboard from "./DetailedDashboard.jsx";
import HeatmapDashboard from "./HeatmapDashboard.jsx";
import NewHeatmapDashboard from "./NewHeatmapDashboard.jsx";

import GRLevelSummary from "./GRLevelSummary.jsx";
import HubNotMappedGRs from "./HubNotMappedGRs.jsx";
// After the tab components so it loads after their CSS
import "./DashboardTheme.css";
import { DashboardHeaderSlotContext } from "./DashboardHeaderSlot.jsx";

const MAIN_TABS = [
  { id: "live", label: "Live Dashboard" },
  { id: "detailed", label: "Detailed Dashboard" },
  { id: "heatmap", label: "Heatmap" },
  { id: "grlevelsummary", label: "GR Level Summary" },
  { id: "hubnotmapped", label: "Hub Not Mapped GRs" },
];

export default function Dashboard() {
  // Global filters
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState("");

  const [activeTab, setActiveTab] = useState("live");
  const [liveSubTab, setLiveSubTab] = useState("all");
  const [detailedSubTab, setDetailedSubTab] = useState("all");
  const [heatmapSubTab, setHeatmapSubTab] = useState("warehouse");
  // Header slot the active tab renders its banner into (section title, last refreshed, actions)
  const [headerSlot, setHeaderSlot] = useState(null);

  // Sub tabs (All Warehouses / GGN-KKD) for the tabs that have them
  const subTabs = {
    live: { value: liveSubTab, set: setLiveSubTab, options: [["all", "All Warehouses"], ["gurgaon", "GGN/KKD"]] },
    detailed: { value: detailedSubTab, set: setDetailedSubTab, options: [["all", "All Warehouses"], ["gurgaon", "GGN/KKD"]] },
    heatmap: { value: heatmapSubTab, set: setHeatmapSubTab, options: [["warehouse", "All Warehouses"], ["gurgaon", "GGN/KKD"]] },
  }[activeTab];

  const globalFilters = { fromDate, toDate, selectedWarehouse };

  return (
    <div className="dashboard-wrapper dashboard-theme">
      <div className="dashboard-container">
        {/* Header */}
        <div className="dashboard-header">
          <div className="dashboard-title-bar" />
          <h1 className="dashboard-title">MSIL Dashboard - Hub and Spoke</h1>
          <div className="dashboard-header-slot" ref={setHeaderSlot} />
        </div>

        {/* Tabs bar: main tabs left, sub tabs right */}
        <div className="dashboard-nav">
          <div className="tabs-list" role="tablist">
            {MAIN_TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`tab-trigger ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {subTabs && (
            <div className="subtab-row">
              {subTabs.options.map(([value, label]) => (
                <button
                  key={value}
                  type="button"
                  aria-pressed={subTabs.value === value}
                  className={`subtab-btn ${subTabs.value === value ? "active" : ""}`}
                  onClick={() => subTabs.set(value)}
                >
                  {label}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Content */}
        <DashboardHeaderSlotContext.Provider value={headerSlot}>
        <div className="tab-content">
          {activeTab === "live" && <LiveDashboard globalFilters={globalFilters} activeSubTab={liveSubTab} />}

          {activeTab === "detailed" && (
            <DetailedDashboard globalFilters={globalFilters} activeSubTab={detailedSubTab} />
          )}

          {activeTab === "heatmap" && (
            <NewHeatmapDashboard globalFilters={globalFilters} activeSubTab={heatmapSubTab} />
          )}

          {activeTab === "grlevelsummary" && <GRLevelSummary globalFilters={globalFilters} />}

          {activeTab === "hubnotmapped" && <HubNotMappedGRs />}
        </div>
        </DashboardHeaderSlotContext.Provider>
      </div>
    </div>
  );
}
